<script lang="tsx">
import { defineComponent, onMounted, ref} from 'vue';
import Button from "@/components/common/buttons/Button.vue";
import iosShareIcon from '@/content/assets/img/webapp-share.svg';
import closeIcon from '@/content/assets/img/close.svg';

let deferredPrompt:any;

// Detects if device is on iOS
function isIOS() {
    return /iPhone|iPad|iPod/.test(navigator.userAgent);
}

// Detects if device is in standalone mode
function isInStandaloneMode() {
    return ('standalone' in window.navigator) && ((window.navigator as any).standalone);
}

//  Beforeinstallprompt handler is only relevant for non iOS devices.
if(!isIOS()){
  window.addEventListener('beforeinstallprompt', function(event:any) {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  event.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = event;  
  });
} 

export default defineComponent({
  name: 'AddToHomeScreen',
  setup(props, context) {
    const isWaitingForEvent = ref(true)
    const addToHomePrompted = ref(localStorage.getItem("AddToHomePrompted") === "true")
    const isPwa = window.matchMedia('(display-mode: standalone)').matches;
    onMounted(() => {
      setTimeout(()=>{
        isWaitingForEvent.value = false
      }, 3000)
    });    

    // Set boolean state for AddToHomePrompted into localstorage
    const addToHome = () => {
      localStorage.setItem("AddToHomePrompted", "true");
      addToHomePrompted.value = true;
    };
    
    const showIosModal = isIOS() && !isInStandaloneMode()
    return () => {
      if(showIosModal && !addToHomePrompted.value) {
        return (
          <div class="add-to-home-modal--ios">
            <div class="popup-text">
              <span>Add the Siemens.FM Web-App to your device: Tap</span>
              &nbsp;&nbsp;
              <img  class="share-icon" src={iosShareIcon} width="24" height="24" alt="Share for iOS"/>
              &nbsp;&nbsp;
              <span>then select the option "Add to Home Screen".</span>
            </div>
            <button onClick={addToHome}>
              <img  class="close-icon" src={closeIcon} width="24" height="24" alt="Close"/>   
            </button>
          </div>
        )
      } 

      if (isWaitingForEvent.value) {
        return null
      } 
      if (isPwa || addToHomePrompted.value || !deferredPrompt) {
        return null; // Or return an empty fragment <> </>
      }

      return (<div class="add-to-home-modal" id="addToHomeModal">
        <div class="home-header">Add to home screen</div>
        <div class="button-bar">
          <Button type="Tertiary"
            onClick={addToHome}
            >
              Cancel
            </Button>
          <Button type="Primary"
            id=""
            ref="addBtn"
            class="button button--Primary"
            onClick={() => {
              deferredPrompt?.prompt()
              
              // Wait for the user to respond to the prompt
              deferredPrompt?.userChoice.then((choiceResult: any) => {
                localStorage.setItem("AddToHomePrompted", "true")
                addToHomePrompted.value = true
              })
            }}
          >
            Add
          </Button>
      </div>
      </div >)
    } 
      
  }
});
</script>
 
 
<style lang="scss" scoped>
@import "src/css/common/index";
 
@include important {
  .add-to-home-modal {
    position: fixed;
    width: min(90vw, 360px);
    top: 5px;
    left: calc(50vw - 180px);
    padding: 1rem;
    border: 2px solid #fff;
    background: lighten(#000028, 5%);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .home-header{
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 32px;
    font-family: "SiemensSans", sans-serif;
    font-weight: 900;
    margin-bottom: 5px;
  } 
  .button-bar{
    display: flex;
    justify-content: center;
    gap: 5px;
    align-items: center;
    margin-top: 1rem;
  } 

  .button--Tertiary{
    padding: 8px 16px;
  }

  .add-to-home-modal--ios {
  font-family: "SiemensSans", sans-serif;
  position: fixed;
  bottom: 0.4rem;
  max-width: 100vw;
  margin: 0 auto;
  box-shadow: 0 10px 17px 0 rgba(78, 78, 78, 0.17);
  background-color: #fff;
  padding: 0.625rem 1.5rem 0.625rem 0.625rem;
  border-radius: 0.625rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  right: 3%;
  left: 3%;
  z-index: 2;
  &:before {
    position: absolute;
    height: 0.4rem;
    z-index: -1;
    content: "";
    left: calc(50% - 0.4rem);
    bottom: -0.7rem;
    border-style: solid;
    border-width: 0.4rem 0.4rem 0.4rem 0.4rem;
    border-color: #fff transparent transparent transparent;
    transition-duration: 0.3s;
    transition-property: transform;
  }
  @media (min-width: 1025px) {
    display: none;
  }
  .popup-text {
    color: #000028;
    font-size: 1rem;
    line-height: 1.5rem;
    padding-top: .5rem 1.5rem .6rem .5rem;
  }

  .close-icon{
    position: absolute;
    right: .5rem;
    top: .5rem;
  } 
  .share-icon{
    position: relative;
    top: 4px;
  } 
}


}
</style>